module.exports = __webpack_public_path__ + "assets/img/Home.d569d633-ps.jpg";